module.exports = __webpack_public_path__ + "img/high_operation.5ceca0a6.png";